// @core/api/endpoints/audittrail/generate_compliance_report.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ComplianceReportResponse,
  GenerateComplianceReportRequest,
} from '../../../types/audittrail';

const BASE_PATH = '/audittrail';

/**
 * Generate compliance report
 * Initiates generation of a compliance report for the specified type and time period. The report is generated asynchronously and a Kafka event is published when ready.
 */
export async function GenerateComplianceReport(
  data: GenerateComplianceReportRequest,
  options?: RequestOptions
): Promise<ComplianceReportResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/audit/compliance-reports`;
  const requestOptions = options;
  return client.post<ComplianceReportResponse>(requestPath, data, requestOptions);
}
